var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaitingFilled = function SvgWaitingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 10C0 4.48 4.47 0 9.99 0 15.52 0 20 4.48 20 10S15.52 20 9.99 20C4.47 20 0 15.52 0 10m9-5h1.5v5.25l4.5 2.67-.75 1.23L9 11z",
    clipRule: "evenodd"
  })));
};
export default SvgWaitingFilled;